import { __rest } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';

var ImageIcon = function ImageIcon(_a) {
  var className = _a.className,
    otherProps = __rest(_a, ["className"]);
  return jsx("svg", Object.assign({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-label": "ImageIcon",
    role: "img",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    fill: "none",
    className: classNames('cogs-icon', className)
  }, otherProps, {
    children: jsx("path", {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M3.392 4.667c0-.704.57-1.275 1.275-1.275h6.666c.705 0 1.275.57 1.275 1.275V8.25l-.095-.096-.01-.01c-.41-.394-.928-.649-1.503-.649s-1.093.255-1.503.65l-.01.009-.154.154L7.846 6.82l-.01-.01c-.41-.395-.927-.65-1.503-.65s-1.092.255-1.502.65l-.01.01L3.39 8.25zm5.435 5.185 1.327 1.327a.725.725 0 0 0 1.025-1.025l-.82-.82.148-.15c.196-.186.367-.239.493-.239s.297.053.493.24l1.115 1.115v1.033c0 .705-.57 1.275-1.275 1.275H4.667c-.704 0-1.275-.57-1.275-1.275V10.3L5.84 7.851c.196-.187.366-.24.492-.24s.297.053.493.24L8.814 9.84zm-6.885 1.481V4.667a2.725 2.725 0 0 1 2.725-2.725h6.666a2.725 2.725 0 0 1 2.725 2.725v6.666a2.725 2.725 0 0 1-2.725 2.725H4.667a2.725 2.725 0 0 1-2.725-2.725M10 4.608a.725.725 0 0 0 0 1.45h.007a.725.725 0 0 0 0-1.45z",
      clipRule: "evenodd"
    })
  }));
};

export { ImageIcon };
